export default __webpack_public_path__ + "static/media/logo-punto-ian.ae1e4e61.png";